import {
    CHANGE_DIRECTION,
    CHANGE_NAVIGATION_STYLE,
    DARK_THEME,
    DRAWER_TYPE,
    FIXED_DRAWER,
    HORIZONTAL_MENU_POSITION,
    INSIDE_THE_HEADER,
    SWITCH_LANGUAGE,
    THEME_COLOR,
    VERTICAL_NAVIGATION,
    WINDOW_WIDTH,
    TITLE
} from 'constants/ActionTypes';
import {DARK_INDIGO, DEEP_PURPLE} from 'constants/ThemeColors';

const rltLocale = ['ar', 'fa'];
const initialSettings = {
    drawerType: FIXED_DRAWER,
    themeColor: DEEP_PURPLE,
    darkTheme: false,
    width: window.innerWidth,
    isDirectionRTL: true,
    title: 'داشبورد',
    navigationStyle: VERTICAL_NAVIGATION,
    horizontalNavPosition: INSIDE_THE_HEADER,
    // locale: {
    //   languageId: 'english',
    //   locale: 'en',
    //   name: 'English',
    //   icon: 'us'
    // }
    locale: {
        languageId: 'persian', // Unique ID for language
        locale: 'fa',         // locale name to link with the previously named locale
        name: 'Persian',      // Display name of the language
        Icon: 'fa'            // To choose the flag of the country
    }


};

const settings = (state = initialSettings, action) => {
    switch (action.type) {
        case DRAWER_TYPE:
            return {
                ...state,
                drawerType: action.drawerType
            };
        case WINDOW_WIDTH:
            return {
                ...state,
                width: action.width
            };
        case THEME_COLOR:
            return {
                ...state,
                darkTheme: false,
                themeColor: action.color
            };
        case DARK_THEME:
            return {
                ...state,
                darkTheme: !state.darkTheme
            };
        case SWITCH_LANGUAGE:

            return {
                ...state,
                locale: action.payload,
                isDirectionRTL: rltLocale.includes(action.payload.locale)

            };
        case CHANGE_DIRECTION:
            return {
                ...state,
                isDirectionRTL: !state.isDirectionRTL

            };

        case TITLE:
            return {
                ...state,
                title: action.payload
            };


        case CHANGE_NAVIGATION_STYLE:
            return {
                ...state,
                navigationStyle: action.payload
            };


        case HORIZONTAL_MENU_POSITION:
            return {
                ...state,
                horizontalNavPosition: action.payload
            };


        default:
            return state;
    }
};

export default settings;
